import React, { useEffect, useState } from 'react'
import { TranscriptHeader } from './TranscriptHeader'
import { EmbeddedTranscriptViewer } from './EmbeddedTranscriptViewer'
import { useAudioStore } from './useAudioStore'
import { Submission } from 'lib/types/generated-types'
import { Transcript } from 'interfaces/db/transcript'
import { IconChevronsDown } from '@tabler/icons-react'

interface TranscriptContainerProps {
  submission: Submission
  transcript: Transcript
}

export const TranscriptContainer: React.FC<TranscriptContainerProps> = ({
  submission,
  transcript,
}) => {
  const {
    isPlaying,
    play,
    pause,
    progress,
    setAudioTime,
    setAudioUrl,
    cleanupAudio,
  } = useAudioStore()
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    return () => {
      cleanupAudio()
    }
  }, [setAudioUrl, cleanupAudio])

  return (
    <div className="relative flex h-full w-full flex-col gap-2">
      <div
        className={`relative w-full flex-1 transition-all duration-300 ${
          isExpanded ? 'overflow-y-auto' : 'overflow-hidden'
        }`}
      >
        <div className={`${isExpanded ? '' : 'max-h-[calc(100vh-8rem)]'}`}>
          <EmbeddedTranscriptViewer
            transcript={transcript}
            isPlaying={isPlaying}
            play={play}
            pause={pause}
            progress={progress}
            setAudioTime={setAudioTime}
          />
        </div>
        {!isExpanded && (
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
        )}
      </div>
      {!isExpanded && (
        <div
          onClick={() => setIsExpanded(true)}
          className="flex cursor-pointer flex-col items-center border-t bg-white py-4"
        >
          <span className="flex animate-pulse items-center gap-1 text-sm font-medium text-gray-600">
            Expand transcript
            <IconChevronsDown className="h-4 w-4" />
          </span>
        </div>
      )}
    </div>
  )
}
